import axios from "axios";

export const heroSectionApi = async () => {
  const response = await axios.get(
    `https://api.nasa.gov/planetary/apod?api_key=${process.env.REACT_APP_API_KEY}`
  );

  return response.data;
};

export const monthlyStoriesApi = async (startDate, endDate) => {
  const response = await axios.get(
    `https://api.nasa.gov/planetary/apod?api_key=${process.env.REACT_APP_API_KEY}&start_date=${startDate}&end_date=${endDate}`
  );

  return response.data;
};